<script>
  import { sgettext } from '../../i18n.js';

  export let data;
  let glyphIcon = "align-left";
  let badgeColor = "grey";
  let elementTypeDisplay = "";

  data = data.toUpperCase();
  $: switch (data) {
    case 'TOOL':
      glyphIcon = "wrench";
      badgeColor = "#02AB8B";
      elementTypeDisplay = sgettext("$$TOOL$$")
      break;
    case 'KNACK':
      glyphIcon = "cog";
      badgeColor = "#1B67B1";
      elementTypeDisplay = sgettext("$$KNACK$$")
      break;
    case 'QUALITY':
      glyphIcon = "search";
      badgeColor = "#2FA3D7";
      elementTypeDisplay = sgettext("$$QUALITY$$")
      break;
    case 'ACTIVITY':
      glyphIcon = "cubes";
      elementTypeDisplay = sgettext("$$ACTIVITY$$")
      break;
    case 'PART':
      glyphIcon = "cube";
      badgeColor = "#9D2F92";
      elementTypeDisplay = sgettext("$$PART$$")
      break;
    case 'SAFETY':
      glyphIcon = "medkit";
      badgeColor = "#F47B2E";
      elementTypeDisplay = sgettext("$$SAFETY$$")
      break;
    default:
      glyphIcon = "cog";
      badgeColor = "#1B67B1";
      break;
  }
</script>

<div class="badge badge-pill" style={`background-color: ${badgeColor}`}>
  <i class={`fa fa-${glyphIcon}`} />
  {elementTypeDisplay}
</div>
